function fileIsFetched (fileId) {
  if (!this.fileOverviews) return
  const fileOverview = this.fileOverviews[fileId]
  if (!fileOverview) return
  return fileOverview.fetched
}

export default fileIsFetched